import React from 'react';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const PhoneNumber = ({
    name,
    value,
    onChange
}) => {
    let inputStyle = {
        width: "-webkit-fill-available",
        marginRight: "0",
    }

    return (
        <PhoneInput
            className=""
            inputStyle={inputStyle}
            country={'in'}
            value={value}
            onChange={(e) => onChange(e, name, 'phone')}
        />
    );
};

export default PhoneNumber;